"use client";
import { jsx as e } from "react/jsx-runtime";
import { InkeepEmbeddedChatImpl as m } from "./embedded-chat.js";
import { InkeepModal as p } from "./modal.js";
import { WebWidgetInteractionType as a } from "@inkeep/cxkit-styled";
function l(t) {
  const { modalSettings: o, baseSettings: n, aiChatSettings: r, ...i } = t;
  return /* @__PURE__ */ e(
    p,
    {
      componentType: a.CustomTrigger,
      modalSettings: o,
      baseSettings: n,
      aiChatSettings: r,
      children: /* @__PURE__ */ e(m, { ...i })
    }
  );
}
export {
  l as InkeepModalChat
};
